import React from 'react';
import styles from '../../../styles.module.css';
import MainIcons from '@/icons/main';

export default function ToggleButton({ open }: { open?: boolean }) {
  return (
    <span className={styles.chevron} data-open={open}>
      <MainIcons.arrowIcon
        width="15px"
        height="15px"
        fill="currentColor"
        className={styles.arrowIcon}
      />
    </span>
  );
}
